export enum DictionaryMode {
  Dynamic,
  Static
}
